import InfoSnippet from './InfoSnippet';

export default InfoSnippet;
